export default function(error) {
  const USER_EMAIL_ALREADY_IN_USE = 'user_email_already_in_use'
  const CANDIDATE_EMAIL_ADDRESS_INVALID = 'candidate_email_address_invalid'
  const CANDIDATE_IS_NOT_R2W_USER = 'candidate_is_not_r2w_user'
  const CANDIDATE_NO_ACTIVE_REGISTRATION = 'candidate_no_active_registration'

  switch (error.code) {
    case USER_EMAIL_ALREADY_IN_USE:
      return "The candidate's email address is already in use."
    case CANDIDATE_EMAIL_ADDRESS_INVALID:
      return "The candidate's email address is not a valid email address."
    case CANDIDATE_IS_NOT_R2W_USER:
      return 'The candidate does not have a Ready2Work login.'
    case CANDIDATE_NO_ACTIVE_REGISTRATION:
      return 'The candidate does not have an active registration.'
    default:
      return 'Oops... something went wrong.'
  }
}
